import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { ReactComponent as ProfileAvatar } from '../../resources/icons/avatar-icon.svg';
import { upperCase } from 'lodash';
import { sizeValues } from '../../utilities';
import { TSize } from '../../resources/types';
import ImageViewer from 'react-simple-image-viewer';
import CloseButton from './CloseButton';

interface IBaseProps {
  size?: TSize;
}

interface IAvatarProps extends IBaseProps {
  src?: string;
  nameInitials?: string;
}

function Avatar({ size = 'md', src, nameInitials }: IAvatarProps): JSX.Element {
  const [loaded, setLoaded] = useState(true);
  const sizes = sizeValues(size);
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const onErrorHandler = () => {
    setLoaded(false);
  };

  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <>
      {src && loaded ? (
        <div className={clsx('flex items-center justify-center rounded-full border-2 text-center', sizes.height, sizes.width)}>
          <img
            src={src}
            alt={upperCase(nameInitials)}
            className='w-full h-full rounded-full hover:cursor-pointer'
            onError={onErrorHandler}
            onClick={() => openImageViewer(0)}
          />
        </div>
      ) : (
        <div className="text-center rounded-full text-gray-700 bg-green-300">
          {nameInitials ? (
            <div className={clsx('flex items-center justify-center', sizes.height, sizes.width)}>
              <h3 className={clsx("text-sm font-bold", { ["text-xs"]: size == "xs" })}>{upperCase(nameInitials)}</h3>
            </div>
          ) : (
            <ProfileAvatar className={clsx(sizes.height, sizes.width, 'text-gray-700')} />
          )}
        </div>
      )}

      {isViewerOpen && src && (
        <div className='z-50'>
          <ImageViewer
            src={[src]}
            currentIndex={currentImage}
            disableScroll={false}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
          // closeComponent={<CloseButton />}
          />
        </div>
      )}
    </>
  );
}

export default Avatar;
